// ABOUTME: React Query hook for one page of the TUC configs audit log (HCP-112400).
import {useQuery} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {api} from '../../../../App.store'
import type {AuditLogFilters, AuditLogPage} from '../auditLogTypes'

export const useAuditLogs = (filters: AuditLogFilters, page: number, pageSize: number) =>
  useQuery<AuditLogPage, AxiosError>({
    queryKey: ['auditLogs', filters, page, pageSize],
    queryFn: async () => {
      const activeFilters = Object.fromEntries(Object.entries(filters).filter(([, value]) => value))
      const res = await api.get<AuditLogPage>('/tuc-configs/audit-logs', {
        params: {...activeFilters, page, pageSize},
      })
      return res.data
    },
    keepPreviousData: true,
    retry: false,
  })
